type AmbassadorRPCBaseConstructor = (...any) => {
  [serviceName: string]: (...any) =>
    (...any) =>
      any
};

type ServiceNames<TRPCConstructor extends AmbassadorRPCBaseConstructor> = keyof ReturnType<TRPCConstructor>;

export type AmbassadorServiceType<TAmbassadorConstructor extends AmbassadorRPCBaseConstructor, TServiceName extends ServiceNames<TAmbassadorConstructor>> =
  ReturnType<
    ReturnType<
      ReturnType<TAmbassadorConstructor>[TServiceName]
    >
  >;

export const snakeToCamelCase = str => str.replace(
    /([-_][a-z])/g,
    (group) => group.toUpperCase()
        .replace('-', '')
        .replace('_', '')
);

export const getMajorVersion = (version: string) => {
  if (version !== undefined && version !== null && version.indexOf('.') !== -1) {
    const versionNumber = Number.parseInt(version.split('.')[0]);
    if (!Number.isNaN(versionNumber)) {
      return versionNumber;
    }
  }
  return (-1);
};
